import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer, X } from "lucide-react";
import { euro } from "@/cart";

export const promoUrl = (code) => `${window.location.origin}/?promo=${encodeURIComponent(code)}#merch`;

const label = (c) => (c.percent_off ? `-${c.percent_off}%` : `-${euro(c.amount_off_cents)}`);

export default function DiscountQr({ discount, onClose }) {
  const wrapRef = useRef(null);
  const url = promoUrl(discount.code);
  const dataUrl = () => wrapRef.current?.querySelector("canvas")?.toDataURL("image/png");

  const download = () => {
    const a = document.createElement("a");
    a.href = dataUrl();
    a.download = `qr-${discount.code}.png`;
    a.click();
  };

  const print = () => {
    const w = window.open("", "_blank", "width=720,height=900");
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>QR ${discount.code}</title>
<style>
  @page{margin:12mm} body{margin:0;font-family:Georgia,serif;color:#111;display:flex;justify-content:center}
  .card{width:92mm;border:2px solid #111;padding:10mm 8mm;text-align:center;page-break-inside:avoid}
  .brand{font:700 11px/1 Arial,sans-serif;letter-spacing:4px;text-transform:uppercase;color:#C8102E}
  h1{font-size:30px;line-height:1;margin:6mm 0 2mm;text-transform:uppercase}
  .code{font:700 26px/1 "Courier New",monospace;letter-spacing:5px;margin:5mm 0 2mm}
  .value{font-size:16px;color:#C8102E;font-weight:700}
  p{font-size:12px;line-height:1.5;color:#444;margin:3mm 0 0}
  img{width:60mm;height:60mm;margin-top:4mm}
  .url{font:10px/1.4 Arial,sans-serif;color:#777;word-break:break-all;margin-top:3mm}
</style></head><body><div class="card">
<div class="brand">Linea Cremisi</div>
<h1>Sconto sul Merch</h1>
<div class="value">${label(discount)} sul tuo ordine</div>
<img src="${dataUrl()}" alt="QR ${discount.code}" />
<div class="code">${discount.code}</div>
<p>Inquadra il QR: il codice si applica da solo al pagamento. Oppure inseriscilo nel carrello su lineacremisi.</p>
<div class="url">${url}</div>
</div><script>window.onload=function(){window.print()}</script></body></html>`);
    w.document.close();
  };

  return (
    <div data-testid="discount-qr-modal" className="fixed inset-0 z-[95] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm" onClick={onClose}>
      <div className="w-full max-w-sm border border-red-900/50 bg-[#0D0D0D] p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-4">
          <div>
            <p className="font-mono-tac text-[10px] uppercase tracking-[0.3em] text-red-600">QR da stampare</p>
            <h3 className="font-display mt-1 text-3xl uppercase text-neutral-100">{discount.code}</h3>
            <p className="text-sm text-red-500">{label(discount)} · si applica da solo al pagamento</p>
          </div>
          <button data-testid="discount-qr-close" onClick={onClose} aria-label="Chiudi" className="flex h-9 w-9 shrink-0 items-center justify-center border border-neutral-800 text-neutral-400 hover:border-red-600 hover:text-red-500"><X className="h-4 w-4" /></button>
        </div>
        <div ref={wrapRef} className="mt-5 flex justify-center bg-white p-4">
          <QRCodeCanvas value={url} size={512} level="M" marginSize={1} style={{ width: 240, height: 240 }} />
        </div>
        <p data-testid="discount-qr-url" className="mt-3 break-all font-mono-tac text-[10px] text-neutral-500">{url}</p>
        <div className="mt-4 grid grid-cols-2 gap-2">
          <button data-testid="discount-qr-download" onClick={download} className="inline-flex h-11 items-center justify-center gap-2 bg-[#C8102E] font-mono-tac text-[10px] uppercase tracking-[0.2em] text-white hover:bg-[#FF2A4B]"><Download className="h-3.5 w-3.5" /> Scarica PNG</button>
          <button data-testid="discount-qr-print" onClick={print} className="inline-flex h-11 items-center justify-center gap-2 border border-neutral-700 font-mono-tac text-[10px] uppercase tracking-[0.2em] text-neutral-200 hover:border-red-600 hover:text-red-500"><Printer className="h-3.5 w-3.5" /> Stampa</button>
        </div>
      </div>
    </div>
  );
}
